import React from 'react';
import { Row } from 'react-bootstrap';
import { FormNumber, Fieldset, FormRadio } from '~/components/FormControl';

function Others() {
    return (
        <Fieldset className={'px-4'}>
            <Fieldset.Legend>Others:</Fieldset.Legend>
            <Row>
                <FormNumber
                    name="bonusExperience"
                    sm={6}
                />
                <FormRadio
                    name="hasCrit"
                    sm={3}
                />
            </Row>
        </Fieldset>
    );
}

export default Others;
